import React from "react";
// import { Button } from "../UI/Contact/button"
import { motion } from "framer-motion";

import { FaPhoneAlt } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { FaFacebookSquare } from "react-icons/fa";

export function FotCard({
  logo,
  brandName,
  socialLinks,
  mainLinks,
  // legalLinks,
  copyright,
}) {
  return (
    <footer className="pb-6 pt-16 bg-black text-white lg:pb-8 lg:pt-8">
      <div className="px-4 lg:px-8">
        <div className="flex md:items-start justify-between">
          <a
            href="/"
            className="flex items-center font-title gap-x-2"
            aria-label={brandName}
          >
            {logo}
            <span className="font-bold text-xl">{brandName}</span>
          </a>
          <ul className="flex list-none mt-6 md:mt-10 space-x-3">
            {socialLinks.map((link, i) => (
              <li key={i}>
                <button className="h-10 w-10 rounded-full">
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={link.label}
                  >
                    {link.icon}
                  </a>
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="border-t mt-6 pt-6 md:mt-4 md:pt-8 flex flex-col md:flex-row gap-8 md:gap-0 md:justify-between">
          <div className=" flex flex-col ssmm:flex-row gap-10 w-full ssmm:w-[400px]  sfm:w-[500px] relative ">
            {[
              {
                icon: IoIosMail,
                title: "Email Us",
                text: "neytprint@gmail.com",
              },
              { icon: FaPhoneAlt, title: "Call Us", text: "+995 511 508 853" },
            ].map((item, i) => (
              <motion.div key={i} whileHover={{ x: 5 }} className="flex gap-3">
                <div className="rounded-3xl bg-muted p-2">
                  <item.icon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-medium">{item.title}</h3>
                  <p className="text-sm text-muted-foreground">{item.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
          <nav className="lg:col-[4/11]">
            <ul className="flex flex-wrap -my-1 -mx-2 lg:justify-end list-none">
              {mainLinks.map((link, i) => (
                <li key={i} className="my-1 mx-2 shrink-0">
                  <a
                    href={link.href}
                    className="text-sm text-primary hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* <div className="mt-6 lg:mt-0 lg:col-[4/11]">
            <ul className="flex flex-wrap -my-1 -mx-3 lg:justify-end list-none">
              {legalLinks.map((link, i) => (
                <li key={i} className="my-1 mx-3 shrink-0">
                  <a
                    href={link.href}
                    className="text-sm text-muted-foreground hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          {/* COPYRIGHT */}
          {/* <div className="mt-6 text-sm text-muted-foreground lg:mt-0 lg:row-[1/3] lg:col-[1/4]">
            <div>{copyright.text}</div>
            {copyright.license && <div>{copyright.license}</div>}
          </div>
  */}
        </div>
      </div>
    </footer>
  );
}
